import { produce } from 'immer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import useMount from '../../../../../../common/hooks/useMount';
import Loader from '../../../../../../common/widgets/Loader';
import { config } from '../../../../config';
import { rewriteImageUrl } from '../../../../helpers';
import { Brand } from '../../../../models/Brands';
import { resources } from '../../../../resources/resources';
import { brandService } from '../../../../services/brand';

interface MostPopularBrandsState {
  data: Brand[] | undefined;
}

interface MostPopularBrandsProps {
  categoryId: number;
}

export default function MostPopularBrands(
  props: Readonly<MostPopularBrandsProps>,
) {
  const { t: translate } = useTranslation();
  const { categoryId } = props;
  const [state, setState] = useState<MostPopularBrandsState>({
    data: undefined,
  } as MostPopularBrandsState);

  const loadBrands = async (abortController: AbortController | undefined) => {
    const result = await brandService.getMostPopular(categoryId, {
      signal: abortController?.signal,
    });

    if (!result.hasErrors) {
      setState(
        produce(d => {
          d.data = result.data;
        }),
      );
    }
  };

  useMount(loadBrands);

  return (
    <section className="page-section mb-60">
      <Loader loading={!state.data} loader={<Skeleton />}>
        <h5 className="section-title">
          {translate(resources.brands.popularBrands)}
        </h5>

        {state.data && (
          <div className="card-list card-list-6 card-list-lg-4 card-list-sm-4 card-list-xxs-2">
            {state.data
              ?.slice(0, config.categoryPageMostPopularBrandsNo)
              .map(b => (
                <Link
                  key={b.id}
                  className="card brand-card"
                  to={`/products/search?brand=${b.id}_${b.name}`}
                >
                  <div className="card-img">
                    {!!b.imageUrl && (
                      <img
                        src={rewriteImageUrl(b.imageUrl ?? '')}
                        alt={b.name}
                        title={b.name}
                      />
                    )}
                  </div>
                </Link>
              ))}
          </div>
        )}
      </Loader>
    </section>
  );
}
